import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { disposables as b } from './disposables.js';
import { match as M } from './match.js';
import { getOwnerDocument as m } from './owner.js';
var f = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map(function (e) {
  return "".concat(e, ":not([tabindex='-1'])");
}).join(",");
var L = function (r) {
    return r[r.First = 1] = "First", r[r.Previous = 2] = "Previous", r[r.Next = 4] = "Next", r[r.Last = 8] = "Last", r[r.WrapAround = 16] = "WrapAround", r[r.NoScroll = 32] = "NoScroll", r;
  }(L || {}),
  N = function (o) {
    return o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o;
  }(N || {}),
  T = function (n) {
    return n[n.Previous = -1] = "Previous", n[n.Next = 1] = "Next", n;
  }(T || {});
function E() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  return e == null ? [] : Array.from(e.querySelectorAll(f)).sort(function (t, n) {
    return Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER));
  });
}
var F = function (n) {
  return n[n.Strict = 0] = "Strict", n[n.Loose = 1] = "Loose", n;
}(F || {});
function h(e) {
  var _M;
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var n;
  return e === ((n = m(e)) == null ? void 0 : n.body) ? !1 : M(t, (_M = {}, _defineProperty(_M, 0, function _() {
    return e.matches(f);
  }), _defineProperty(_M, 1, function _() {
    var l = e;
    for (; l !== null;) {
      if (l.matches(f)) return !0;
      l = l.parentElement;
    }
    return !1;
  }), _M));
}
function g(e) {
  var t = m(e);
  b().nextFrame(function () {
    t && !h(t.activeElement, 0) && S(e);
  });
}
function S(e) {
  e == null || e.focus({
    preventScroll: !0
  });
}
var H = ["textarea", "input"].join(",");
function w(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, H)) != null ? n : !1;
}
function A(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (n) {
    return n;
  };
  return e.slice().sort(function (n, l) {
    var o = t(n),
      i = t(l);
    if (o === null || i === null) return 0;
    var r = o.compareDocumentPosition(i);
    return r & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : r & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function v(e, t) {
  return I(E(), t, {
    relativeTo: e
  });
}
function I(e, t) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$sorted = _ref.sorted,
    n = _ref$sorted === void 0 ? !0 : _ref$sorted,
    _ref$relativeTo = _ref.relativeTo,
    l = _ref$relativeTo === void 0 ? null : _ref$relativeTo,
    _ref$skipElements = _ref.skipElements,
    o = _ref$skipElements === void 0 ? [] : _ref$skipElements;
  var i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument,
    r = Array.isArray(e) ? n ? A(e) : e : E(e);
  o.length > 0 && r.length > 1 && (r = r.filter(function (s) {
    return !o.includes(s);
  })), l = l != null ? l : i.activeElement;
  var d = function () {
      if (t & 5) return 1;
      if (t & 10) return -1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    }(),
    x = function () {
      if (t & 1) return 0;
      if (t & 2) return Math.max(0, r.indexOf(l)) - 1;
      if (t & 4) return Math.max(0, r.indexOf(l)) + 1;
      if (t & 8) return r.length - 1;
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    }(),
    p = t & 32 ? {
      preventScroll: !0
    } : {},
    c = 0,
    a = r.length,
    u;
  do {
    if (c >= a || c + a <= 0) return 0;
    var s = x + c;
    if (t & 16) s = (s + a) % a;else {
      if (s < 0) return 3;
      if (s >= a) return 1;
    }
    u = r[s], u == null || u.focus(p), c += d;
  } while (u !== i.activeElement);
  return t & 6 && w(u) && u.select(), u.hasAttribute("tabindex") || u.setAttribute("tabindex", "0"), 2;
}
export { L as Focus, N as FocusResult, F as FocusableMode, S as focusElement, v as focusFrom, I as focusIn, E as getFocusableElements, h as isFocusableElement, g as restoreFocusIfNecessary, A as sortByDomNode };